import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const issueConfigProviderEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "ai-rovo-actions-issue-config-provider" */ './IssueConfigProvider'
		).then((module) => module.IssueConfigProviderEntry),
	),
	getPreloadProps: () => ({}),
});
